export default __webpack_public_path__ + "static/media/check.85cf998b.svg";